<template lang="pug">
.assinatura-pessoa
    .logo-slot
        .logo-box
            img.logo(src='@/assets/car-logo-descricao.jpg', alt='')
    .content-slot
        .assinatura-infos {{ assinatura.dataAssinatura ? 'Documento assinado digitalmente por:' : 'Documento não assinado!' }}
        .linha
        .assinatura-infos
        .assinatura-infos.b {{ assinatura.nome }}
        .assinatura-infos.b {{ getTipoAssinatura(assinatura) }}
        //- .assinatura-infos CPF: {{ assinatura.cpfCpnj }}
        .assinatura-infos(:style="{ color: assinatura.dataAssinatura ? '' : 'red' }") Data: {{ getFormatedDate() }}
        .assinatura-infos {{ urlBase + '/analise-prada/#/validacao-termo-compromisso' }}
</template>

<script>
import moment from 'moment';
import { TipoAssinaturaEnum } from '@/enums/processo.enum.js';

export default {

    name: 'AssinaturaBoxComponent',

    props: {
        assinatura: {
            type: Object,
            required: true
        },
        isRepresentanteLegal: {
            type: Boolean,
            required: true
        }
    },

    components: {
    },

    data() {
        return {
            TipoAssinaturaEnum,
            urlBase: process.env.VUE_APP_SICAR_URL,
        }
    },

    methods: {
        getFormatedDate() {
            if (this.assinatura.dataAssinatura) return moment.utc(String(this.assinatura.dataAssinatura)).format('DD/MM/YYYY HH:mm:ss');
            return 'Assinatura pendente';
        },
        getTipoAssinatura(assinatura) {
            const idTipo = assinatura.idTipoAssinaturaTermo;

             if (this.isRepresentanteLegal &&
                idTipo === TipoAssinaturaEnum.COMPROMISSARIO.id) {
                return 'Representante legal';
            }

            const tiposAssinatura = {
                1: TipoAssinaturaEnum.GERENTE_OPERACIONAL.nome,
                2: TipoAssinaturaEnum.PROPRIETARIO_POSSUIDOR.nome,
                3: TipoAssinaturaEnum.COMPROMISSARIO.nome
            };
            if (assinatura.cpfCpnj === '148.866.018-20' && idTipo === TipoAssinaturaEnum.GERENTE_OPERACIONAL.id) {
                return  'Técnico responsável pela SAA'
            } else {
                return tiposAssinatura[idTipo];
            }
        }

    }
}
</script>

<style lang="scss">
.assinatura-pessoa {
    display: flex;
    flex-direction: row;
    flex-wrap: nowrap;

    padding: 5px;
    margin: 5px;
    width: 300px;
    border: 1px solid var(--primary-black);
    border-radius: 5px;

    font-size: 10px;

    .logo-slot {

        padding: 5px;

        .logo {
            width: 50px;
        }
    }

    .content-slot {
        .b {
            font-weight: bolder;
        }
    }
}
</style>
